import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/SinglePlace/SinglePlace.tsx");
